import React from 'react'

const CustomCellRender = ({ id, value }) => {
  return <div data-testid={id}>{value || "-"}</div>;
}

export default CustomCellRender;